import ReactSelect from '@common/ReactSelect';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getMasterConfig, getDealesList } from '@src/store/slices/common';
import { Calendra2 } from '@src/common/DatePicker';
import InputField from '@common/InputField';
import React from 'react';
import { useLanguage } from '@src/context/LanguageContext';
import moment from "moment";
import { CLIENT_REFERRAL, AGENT, DSA, APP_TYPE_STANDALONE, APP_TYPE_RENEWAL, APP_TYPE_AGENCY,FEATURE_LISTING, EREFER,INS_INSURANCE_ID_STAGE, COUNTRY_CODE, LEAD_TYPE_CRM, VALID_LEAD_SOURCE_FOR_ID} from '@src/config/constant';
import DepreciationRates from './DepreciationRates';


export default function OtherDetails(props: any) {
    const isCountryId = COUNTRY_CODE ==='id' ? true : false;
    let { otherDetails, errors } = props;    
    const commonState = useSelector((state: any) => state.common);
    const insuranceState = useSelector((state: any) => state.insurance);
    const { application_type_id } = insuranceState?.leadDetail || {}
    const dispatch: any = useDispatch();
    const [insuranceLeadSource, setInsuranceLeadSource] = useState(otherDetails?.insurance_lead_source);
    // eslint-disable-next-line
    const [paidByCustomer, setPaidByCustomer] = useState(otherDetails?.paid_by_customer);
    const {translations} = useLanguage();
    
    const insuranceEndingDate =
        otherDetails?.insurance_ending_date ||
        (() => {
            const startDate = otherDetails?.insurance_starting_date;
            const tenureYears = Number(otherDetails?.tenure);
            const parsedStartDate = moment(startDate);

            if (!startDate || !parsedStartDate.isValid() || !tenureYears || tenureYears <= 0) return null;
            return parsedStartDate.clone().add(tenureYears, 'year').toISOString();
        })();

    const changeHandler = (value: any, key: string) => {
        let formFields: any = otherDetails;
        if (key === "financing_from_date") {
            // Reset "Financing Till Date" when "Financing From Date" is changed
            formFields = { ...formFields, financing_to_date: null, [key]: value ? new Date(value).toISOString() : '' };
        }
        else if (["financing_from_date", "financing_to_date", "insurance_expire_date", 'insurance_starting_date'].includes(key)) {
            formFields = { ...formFields, [key]: value ? new Date(value).toISOString() : '' }
        } else if (["is_under_financing", "payment_method_id", "payment_term_id", "copy_of_insurance", "insurance_exists", "financier_id", "lead_source", "other_detail_dealer_id", "lead_sub_source", "paid_by_customer", "paid_to_whom", "paid_from_agency", 'usage_type', 'vehicle_condition_id', 'insurance_type_id', 'tenure'].includes(key)) {
            formFields = { ...formFields, [key]: value.value }
        } else if (key === "insurance_lead_source") {
            //  reset agent/ client referal vice versa
            if (+insuranceState?.leadDetail?.insurance_lead_source === +value.value) {
                formFields = { ...formFields, [key]: value.value, referrer_name: insuranceState?.leadDetail?.referrer_name, referrer_mobile: insuranceState?.leadDetail?.referrer_mobile }
            } else {
                formFields = { ...formFields, [key]: value.value, referrer_mobile: "", referrer_name: "", lead_sub_source: null }
            }
            setInsuranceLeadSource(value.value);
        }
        else {
            formFields = { ...formFields, [key]: value?.target?.value }
        }
        props.changeHandler(formFields, "other-details");
    }

    useEffect(() => {
        if (Object.keys(commonState?.common).length === 0) {
            dispatch(getMasterConfig());
        }
        if (Object.keys(commonState?.getDealerList).length === 0) {
            dispatch(getDealesList());
        }
        // eslint-disable-next-line
    }, []);

    const isVehicleConditionDisabled = INS_INSURANCE_ID_STAGE?true:false;
    const uniqueLeadSourceIds = [...new Set(commonState?.common.lead_sub_source?.map((item:any) => item?.lead_source_id))];
    const matchedSource = commonState?.common?.lead_source?.find((item: any) => +item.value === +insuranceLeadSource);
    const leadLabel = matchedSource?.label || 'Marketing';
    const tenureOptions = COUNTRY_CODE === 'id' ? commonState?.common?.tenure_year : commonState?.common?.tenure;
    
    const fieldMapping: any = {
        USAGE_TYPE: (
            <ReactSelect
                options={commonState?.common?.vehicle_usage}
                value={commonState?.common?.vehicle_usage?.find((v: any) => otherDetails?.usage_type === v.value) || {}}
                placeholder={`${translations.Insurance?.['Usage Type'] || translations.commonMsg?.loading}*`}
                isDisabled={false}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="usage_type"
                fieldSetClassName="col-md-6"
                errorField={errors.usage_type}
            />
        ),

        VEHICLE_CONDITION: (
            <ReactSelect
                options={commonState?.common?.vehicle_condition}
                value={commonState?.common?.vehicle_condition?.find((v: any) => otherDetails?.vehicle_condition_id === v.value) || {}}
                placeholder={`${translations.Insurance?.['Vehicle Condition'] || translations.commonMsg?.loading}*`}
                isDisabled={isVehicleConditionDisabled}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="vehicle_condition_id"
                fieldSetClassName="col-md-6"
                errorField={errors.vehicle_condition_id}
            />
        ),

        INSURANCE_TYPE: (
            <ReactSelect
                options={commonState?.common?.insurance_type}
                value={commonState?.common?.insurance_type?.find((v: any) => otherDetails?.insurance_type_id === v.value) || {}}
                placeholder={`${translations.Insurance?.['Insurance Type'] || translations.commonMsg?.loading}*`}
                isDisabled={false}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="insurance_type_id"
                fieldSetClassName="col-md-6"
                errorField={errors.insurance_type_id}
            />
        ),

        CAR_UNDER_FINANCE: (
            <ReactSelect
                options={commonState?.common?.YesAndNo}
                value={commonState?.common?.YesAndNo?.find((v: any) => otherDetails?.is_under_financing === v.value) || {}}
                placeholder={"Vehicle Under Financing*"}
                isDisabled={false}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="is_under_financing"
                fieldSetClassName="col-md-6"
                errorField={errors.is_under_financing}
            />
        ),

        TENURE: (
            <ReactSelect
                options={tenureOptions}
                value={tenureOptions?.find((v: any) => otherDetails?.tenure === v.value) || {}}
                placeholder={`${translations.Insurance?.['Tenure'] || translations.commonMsg?.loading}*`}
                isDisabled={isCountryId}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="tenure"
                fieldSetClassName="col-md-6"
                errorField={errors.tenure}
            />
        ),

        INSURANCE_STARTING_DATE: (
            <>
                <fieldset className="col-md-6 date-picker-detail">
                    <div className={"material animation-effect" + (otherDetails.insurance_starting_date ? ' active-label' : '')}>
                        <Calendra2
                            onChange={(e: Date) => changeHandler(e, 'insurance_starting_date')}
                            dateFormat="dd/MM/yyyy"
                            selected={moment(otherDetails?.insurance_starting_date).format("DD/MMM/YYYY")}
                            fieldLabel={"Insurance Starting Date"}
                            placeholder={`${translations.Insurance?.['Insurance Starting Date'] || translations.commonMsg?.loading}*`}
                        />
                        {
                            errors?.insurance_starting_date ?
                                <span className="error-txt">{errors.insurance_starting_date}</span>
                                : null
                        }
                    </div>
                </fieldset>
                {
                    isCountryId && (
                        <fieldset className="col-md-6 date-picker-detail">
                            <div className={"material animation-effect" + (insuranceEndingDate ? ' active-label' : '')}>
                                <Calendra2
                                    onChange={() => null}
                                    dateFormat="dd/MM/yyyy"
                                    selected={insuranceEndingDate}
                                    fieldLabel={"Insurance Ending Date"}
                                    placeholder={`${translations.Insurance?.['INS_END_DATE']}`}
                                    disabled={true}
                                />
                            </div>
                        </fieldset>
                    )
                }
            </>
        ),

        FINANCIER: (
            otherDetails?.is_under_financing === 1
                ?
                <>
                    <ReactSelect
                        options={commonState?.common?.financier}
                        value={commonState?.common?.financier?.find((e: any) => e.value === otherDetails?.financier_id)}
                        placeholder={`Financier Name ${application_type_id !== APP_TYPE_AGENCY ? '*' : ''}`}
                        isDisabled={false}
                        handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="financier_id"
                        fieldSetClassName="col-md-6"
                        errorField={errors.financier_id}
                    />
                    {
                        application_type_id !== APP_TYPE_AGENCY
                            ?
                            <>
                                <fieldset className="col-md-6 date-picker-detail">
                                    <div className={"material animation-effect" + (otherDetails.financing_from_date ? ' active-label' : '')}>
                                        <Calendra2
                                            onChange={(e: Date) => changeHandler(e, 'financing_from_date')}
                                            dateFormat="dd/MM/yyyy"
                                            selected={otherDetails?.financing_from_date}
                                            fieldLabel={"Financing From Date"}
                                            placeholder={"Financing From Date*"}
                                            fieldname={"finance_from_date"}
                                            apptype={insuranceState?.leadDetail?.application_type_id}
                                        />
                                        {
                                            errors?.financing_from_date ?
                                                <span className="error-txt">{errors.financing_from_date}</span>
                                                : null
                                        }
                                    </div>
                                </fieldset>
                                <fieldset className="col-md-6 date-picker-detail">
                                    <div className={"material animation-effect" + (otherDetails.financing_to_date ? ' active-label' : '')}>
                                        <Calendra2
                                            onChange={(e: Date) => changeHandler(e, 'financing_to_date')}
                                            dateFormat="dd/MM/yyyy"
                                            selected={otherDetails?.financing_to_date}
                                            fieldLabel={"Financing Till Date"}
                                            placeholder={"Financing Till Date*"}
                                            // this props pass as it is, beacuse of condition satisfy the logic for till date
                                            fields={[{ label: 'Financing From Date', value: otherDetails?.financing_from_date, name: 'finance_from_date' }]}
                                            fieldname={"finance_to_date"}
                                            apptype={insuranceState?.leadDetail?.application_type_id}
                                        />
                                        {
                                            errors?.financing_to_date ?
                                                <span className="error-txt">{errors.financing_to_date}</span>
                                                : null
                                        }
                                    </div>
                                </fieldset>
                            </>
                            : null
                    }
                </>
                :
                null
        ),

        INSURANCE_EXISTS:(
            <ReactSelect
                    options={commonState?.common?.YesAndNo}
                    value={commonState?.common?.YesAndNo?.find((v: any) => otherDetails?.insurance_exists === v.value) || {}}
                    placeholder={"Insurance Policy Exists*"}
                    isDisabled={insuranceState?.leadDetail?.application_type_id === APP_TYPE_RENEWAL ? true : false}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="insurance_exists"
                    fieldSetClassName="col-md-6"
                />
        ),

        INSURANCE_EXISTS_FIELDS: (
            otherDetails?.insurance_exists === 1
                ?
                <>
                    <fieldset className="col-md-6">
                        <div className="material" title={otherDetails?.insurer_name}>
                            <InputField
                                inputProps={{
                                    id: "insurer_name",
                                    name: "insurer_name",
                                    className: "form-input",
                                    type: "text",
                                    value: otherDetails?.insurer_name || '',
                                    maxLength: "",
                                    disabled: insuranceState?.leadDetail?.application_type_id === APP_TYPE_RENEWAL ? true : false,
                                    placeholder: " "
                                }}
                                onChange={(e: any) => changeHandler(e, 'insurer_name')}
                            />
                            <label data-label={`Insurance Policy Insurer ${application_type_id !== APP_TYPE_AGENCY ? '*' : ''}`} className="form-label"></label>
                            {
                                errors?.insurer_name ?
                                    <span className="error-txt">{errors.insurer_name}</span>
                                    : null
                            }
                        </div>
                    </fieldset>
                    <fieldset className="col-md-6 date-picker-detail">
                        <div className={"material animation-effect" + (otherDetails?.insurance_expire_date ? ' active-label' : '')}>
                            <Calendra2
                                onChange={(e: Date) => changeHandler(e, 'insurance_expire_date')}
                                dateFormat="dd/MM/yyyy"
                                selected={otherDetails?.insurance_expire_date}
                                fieldLabel={"Insurance Policy Expiration Date"}
                                placeholder={`Existing Policy Expiry Date ${application_type_id !== APP_TYPE_AGENCY ? '*' : ''}`}
                                disabled={insuranceState?.leadDetail?.application_type_id === APP_TYPE_RENEWAL ? true : null} />
                            {
                                errors?.insurance_expire_date ?
                                    <span className="error-txt">{errors.insurance_expire_date}</span>
                                    : null
                            }
                        </div>
                    </fieldset>
                </>
                :
                null
        ),

        LEAD_SOURCE: (
            (application_type_id !== APP_TYPE_AGENCY || isCountryId)
                ?
                <ReactSelect
                    options={commonState?.common?.lead_source}
                    value={commonState?.common?.lead_source?.find((v: any) => +insuranceLeadSource === v.value) || {}}
                    placeholder={isCountryId? translations.Insurance?.['Lead Source']: `${translations.Insurance?.['Lead Source']}*`}
                    isDisabled={(insuranceState?.leadDetail?.application_type_id === APP_TYPE_RENEWAL || isCountryId) ? true : false}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="insurance_lead_source"
                    fieldSetClassName="col-md-6"
                />
                :
                null
        ),

        LEAD_SUB_SOURCE: (
            uniqueLeadSourceIds.includes(+otherDetails?.insurance_lead_source) && <ReactSelect
                options={commonState?.common?.lead_sub_source.filter((e:any) => +e.lead_source_id === +otherDetails?.insurance_lead_source)}
                value={commonState?.common?.lead_sub_source?.find((v: any) => +otherDetails?.lead_sub_source === +v.value) || null}
                placeholder={`${leadLabel} Lead Category*`}
                isDisabled={false}
                handleChange={(e: any) => changeHandler(e, 'lead_sub_source')} fieldKey="lead_sub_source"
                fieldSetClassName="col-md-6"
                errorField={errors['lead_sub_source']}
            />
        ),

        REFERRER_INSURER_NAME: (
            (isCountryId ? (insuranceState?.leadDetail?.lead_type === LEAD_TYPE_CRM  &&  VALID_LEAD_SOURCE_FOR_ID.includes(otherDetails?.insurance_lead_source)) :( otherDetails?.insurance_lead_source === CLIENT_REFERRAL || otherDetails?.insurance_lead_source === AGENT || otherDetails?.insurance_lead_source === DSA || otherDetails?.insurance_lead_source === EREFER )) &&
            (
                <>
                    <fieldset className="col-md-6">
                        <div className="material" title={otherDetails?.insurer_name}>
                            <InputField
                                inputProps={{
                                    id: "referrer_name",
                                    name: "referrer_name",
                                    className: "form-input",
                                    type: "text",
                                    value: otherDetails?.referrer_name,
                                    maxLength: "",
                                    disabled: false,
                                    placeholder: " "
                                }}
                                onChange={(e: any) => changeHandler(e, 'referrer_name')}
                            />
                            <label data-label={(insuranceLeadSource === CLIENT_REFERRAL || isCountryId)
                                ? translations.Insurance?.["Referrer Name"]
                                : insuranceLeadSource === DSA
                                    ? "Agency Name*"
                                    : insuranceLeadSource === AGENT
                                        ? "Agent Name*"
                                    :insuranceLeadSource === EREFER
                                        ? "Employee Name*"    
                                        : ""} className="form-label"></label>
                            {
                                errors?.referrer_name ?
                                    <span className="error-txt">{errors.referrer_name}</span>
                                    : null
                            }
                        </div>
                    </fieldset>
                </>
            )
        ),

        REFERRER_INSURER_MOBILE: (
            (isCountryId ? (insuranceState?.leadDetail?.lead_type === LEAD_TYPE_CRM &&  VALID_LEAD_SOURCE_FOR_ID.includes(otherDetails?.insurance_lead_source) ) :( (otherDetails?.insurance_lead_source === CLIENT_REFERRAL) || (otherDetails?.insurance_lead_source === AGENT) || (otherDetails?.insurance_lead_source === EREFER)))
            &&
            (
                <>

                    <fieldset className="col-md-6">
                        <div className="material" title={otherDetails?.referrer_mobile}>
                            <InputField
                                inputProps={{
                                    id: otherDetails?.insurance_lead_source === EREFER ? "employee_no" : "mobile",
                                    name: "referrer_mobile",
                                    className: "form-input",
                                    type: "text",
                                    value: otherDetails?.referrer_mobile ,
                                    maxLength: otherDetails?.insurance_lead_source === EREFER ? "" : 10,
                                    disabled: false,
                                    placeholder: " "
                                }}
                                onChange={(e: any) => changeHandler(e, 'referrer_mobile')}
                            />
                            <label data-label={
                                        (insuranceLeadSource === CLIENT_REFERRAL || isCountryId) 
                                            ? translations.Insurance?.["Referrer Mobile Number"]
                                            : insuranceLeadSource === AGENT 
                                                ? "Agent Contact Number*" 
                                                : insuranceLeadSource === EREFER 
                                                    ? "Employee Number*" 
                                                    : "Mobile Number*"
                                    }  className="form-label"></label>
                            {
                                errors?.referrer_mobile ?
                                    <span className="error-txt">{errors.referrer_mobile}</span>
                                    : null
                            }
                        </div>
                    </fieldset>
                </>
            )
        ),

        DEALER: (
            [APP_TYPE_STANDALONE].includes(insuranceState?.leadDetail?.application_type_id) &&
            <ReactSelect
                options={commonState.getDealerList}
                value={commonState.getDealerList?.find((v: any) => otherDetails.other_detail_dealer_id === v.value) || []}
                placeholder={"Dealer"}
                isDisabled={false}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="other_detail_dealer_id"
                fieldSetClassName="col-md-6"
            />
        ),

        PAID_BY_CUSTOMER_PAID_BY_WHOM: (
            [APP_TYPE_STANDALONE, APP_TYPE_RENEWAL].includes(insuranceState?.leadDetail?.application_type_id) &&
            <>
                <ReactSelect
                    options={commonState?.common?.paid_by_customer}
                    value={commonState?.common?.paid_by_customer?.find((v: any) => +otherDetails.paid_by_customer === +v.value) || []}
                    placeholder={"Paid By Customer*"}
                    isDisabled={+paidByCustomer === 1 ? true : false}
                    handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="paid_by_customer"
                    fieldSetClassName="col-md-6"
                />
                {
                    +otherDetails?.paid_by_customer === 1 &&
                    <ReactSelect
                        options={commonState?.common?.paid_to_whom}
                        value={commonState?.common?.paid_to_whom?.find((v: any) => +otherDetails.paid_to_whom === +v.value) || []}
                        placeholder={"Paid to whom*"}
                        isDisabled={+paidByCustomer === 1 ? true : false}
                        handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="paid_to_whom"
                        fieldSetClassName="col-md-6"
                        errorField={errors['paid_to_whom']}
                    />
                }
            </>
        ),

        INSURANCE_CATEGORY: (
            <ReactSelect
                options={commonState?.common?.insurance_category}
                value={commonState?.common?.insurance_category?.find((v: any) => v.value == 1) || {}}
                placeholder={`${translations.Insurance?.['Insurance Category'] || translations.commonMsg?.loading}*`}
                isDisabled={true}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="insurance_category"
                fieldSetClassName="col-md-6"
                errorField={errors.vehicle_condition_id}
            />
        ),

        POLICY_HOLDER: (
            <ReactSelect
                options={commonState?.common?.policy_holder}
                value={commonState?.common?.policy_holder?.find((v: any) => v.value === +otherDetails?.policy_holder ) || {}}
                placeholder={`${translations.Insurance?.['Policy Holder'] || translations.commonMsg?.loading}*`}
                isDisabled={true}
                handleChange={(e: any, fieldKey: string) => changeHandler(e, fieldKey)} fieldKey="policy_holder"
                fieldSetClassName="col-md-6"
            />
        )
    }

    const visibleFields = Object.keys(fieldMapping).filter((field: any) => FEATURE_LISTING['LEAD_DETAILS']['INSURANCE_DETAILS']['CUSTOMER_DETAILS']['OTHER_DETAILS'][field])

    return (
        <div>
            <h2>{translations.Insurance?.['Other Details'] || translations.commonMsg?.loading}</h2>
            <div className="row">
                {
                    visibleFields?.map((field: any,index:number) => {
                        
                        return (
                            <React.Fragment key={field}>
                                {
                                    field==='INSURANCE_STARTING_DATE' && COUNTRY_CODE === 'id' && (
                                        <DepreciationRates
                                            lead_tenure_data={insuranceState?.leadDetail?.lead_tenure_data}
                                            disabled={props.disable}
                                            onErrorChange={props.onDepreciationRateError}
                                            onChange={(changedData: any) => {
                                                const formFields = { ...otherDetails, multi_year: changedData };
                                                props.changeHandler(formFields, "other-details");
                                            }}
                                        />
                                    )
                                }
                                {fieldMapping[field]}
                            </React.Fragment>
                        )
                    })
                }
            </div>
        </div>
    )
}
